import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Reveal } from './Reveal';

export function CtaBand() {
  const navigate = useNavigate();

  return (
    <section className="relative isolate overflow-hidden py-20 sm:py-28">
      {/* Glow rising from the bottom edge */}
      <div className="glow-hero absolute inset-0 -z-10 rotate-180" aria-hidden />

      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <Reveal>
          <div className="glass-card rounded-2xl px-6 py-14 text-center sm:px-14">
            <h2 className="text-balance text-3xl font-semibold tracking-tight sm:text-4xl">
              Stop guessing what your AI agents cost.
            </h2>
            <p className="mt-3 text-base text-muted-foreground">
              Join the teams instrumenting AI spend with the same rigor as
              their cloud bill.
            </p>
            <Button
              size="xl"
              className="mt-8"
              onClick={() => navigate('/signup')}
            >
              Start free
              <ArrowRight />
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
